import React, { Component } from 'react'
import * as R from 'ramda'
import Numeral from 'numeral'

export default class CalcTooltip extends Component{
	render(){
		let { props } = this
		return(
			<div style={{display: "inline-block"}}>
				<table cellSpacing="0" style={{float: "left"}}>
					{
						R.values(R.mapObjIndexed((obj, fieldName) => (
							R.values(R.mapObjIndexed((value, sign) => (
								<tr>
									<td >{sign != 'total' && sign != 'first' && sign}</td>
									<td style={{textTransform: "capitalize", borderTop: sign == 'total' || sign.indexOf("%") != -1? "1px solid #FFF" : 'none', paddingRight: "15px"}}>{fieldName != 'total' && fieldName}</td>
									<td style={{textAlign: "right", borderTop: sign == 'total' || sign.indexOf("%") != -1? "1px solid #FFF" : 'none'}}>{value}</td>
								</tr>
								)
							)(obj))
						))(props.data))
					}
				</table>
				<div
					style={{textAlign: "right", cursor: "pointer", float: "right", marginLeft: "10px"}}
					onClick={props.close}
				>
					<i className="material-icons" style={{fontSize: "18px", color: "rgba(255, 255, 255, 0.4)"}}>clear</i>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CalcTooltip.js